<template>
  <div class="bg-gray-900 px-3 pb-1 pt-3">
    <div>
      <div
        v-tooltip="{
          content: $t('layout.after_click_banner'),
        }"
        class="propagation-box cursor-pointer rounded-md p-0.5"
        @click="clickOnBanner"
      >
        <div
          class="flex items-center justify-center gap-3 rounded-md border bg-gray-900 py-1"
        >
          <div style="display: flex; align-items: center">
            <svg
              height="40"
              viewBox="0 0 43 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_4667_1670)">
                <path
                  d="M25.6602 11.0391L29 9.75L30.2305 6.46875C30.2891 6.17578 30.582 6 30.875 6C31.1094 6 31.4023 6.17578 31.4609 6.46875L32.75 9.75L36.0312 11.0391C36.3242 11.0977 36.5 11.3906 36.5 11.625C36.5 11.918 36.3242 12.2109 36.0312 12.2695L32.75 13.5L31.4609 16.8398C31.4023 17.0742 31.1094 17.25 30.875 17.25C30.582 17.25 30.2891 17.0742 30.2305 16.8398L29 13.5L25.6602 12.2695C25.4258 12.2109 25.25 11.918 25.25 11.625C25.25 11.3906 25.4258 11.0977 25.6602 11.0391ZM18.5117 10.3359L21.5586 17.0156L28.2383 20.0625C28.5898 20.2383 28.8242 20.5898 28.8242 20.9414C28.8242 21.293 28.5898 21.6445 28.2383 21.7617L21.5586 24.8672L18.5117 31.5469C18.3359 31.8984 17.9844 32.1328 17.6328 32.1328C17.2812 32.1328 16.9297 31.8984 16.8125 31.5469L13.707 24.8672L7.02734 21.8203C6.67578 21.6445 6.5 21.293 6.5 20.9414C6.5 20.5898 6.67578 20.2383 7.02734 20.0625L13.707 17.0156L16.8125 10.3359C16.9297 9.98437 17.2812 9.75 17.6328 9.75C17.9844 9.75 18.3359 9.98437 18.5117 10.3359ZM29 28.5L30.2305 25.2188C30.2891 24.9258 30.582 24.75 30.875 24.75C31.1094 24.75 31.4023 24.9258 31.4609 25.2188L32.75 28.5L36.0312 29.7891C36.3242 29.8477 36.5 30.1406 36.5 30.375C36.5 30.668 36.3242 30.9609 36.0312 31.0195L32.75 32.25L31.4609 35.5898C31.4023 35.8242 31.1094 36 30.875 36C30.582 36 30.2891 35.8242 30.2305 35.5898L29 32.25L25.6602 31.0195C25.4258 30.9609 25.25 30.668 25.25 30.375C25.25 30.1406 25.4258 29.8477 25.6602 29.7891L29 28.5Z"
                  fill="white"
                />
                <path
                  d="M25.6602 11.0391L29 9.75L30.2305 6.46875C30.2891 6.17578 30.582 6 30.875 6C31.1094 6 31.4023 6.17578 31.4609 6.46875L32.75 9.75L36.0312 11.0391C36.3242 11.0977 36.5 11.3906 36.5 11.625C36.5 11.918 36.3242 12.2109 36.0312 12.2695L32.75 13.5L31.4609 16.8398C31.4023 17.0742 31.1094 17.25 30.875 17.25C30.582 17.25 30.2891 17.0742 30.2305 16.8398L29 13.5L25.6602 12.2695C25.4258 12.2109 25.25 11.918 25.25 11.625C25.25 11.3906 25.4258 11.0977 25.6602 11.0391ZM18.5117 10.3359L21.5586 17.0156L28.2383 20.0625C28.5898 20.2383 28.8242 20.5898 28.8242 20.9414C28.8242 21.293 28.5898 21.6445 28.2383 21.7617L21.5586 24.8672L18.5117 31.5469C18.3359 31.8984 17.9844 32.1328 17.6328 32.1328C17.2812 32.1328 16.9297 31.8984 16.8125 31.5469L13.707 24.8672L7.02734 21.8203C6.67578 21.6445 6.5 21.293 6.5 20.9414C6.5 20.5898 6.67578 20.2383 7.02734 20.0625L13.707 17.0156L16.8125 10.3359C16.9297 9.98437 17.2812 9.75 17.6328 9.75C17.9844 9.75 18.3359 9.98437 18.5117 10.3359ZM29 28.5L30.2305 25.2188C30.2891 24.9258 30.582 24.75 30.875 24.75C31.1094 24.75 31.4023 24.9258 31.4609 25.2188L32.75 28.5L36.0312 29.7891C36.3242 29.8477 36.5 30.1406 36.5 30.375C36.5 30.668 36.3242 30.9609 36.0312 31.0195L32.75 32.25L31.4609 35.5898C31.4023 35.8242 31.1094 36 30.875 36C30.582 36 30.2891 35.8242 30.2305 35.5898L29 32.25L25.6602 31.0195C25.4258 30.9609 25.25 30.668 25.25 30.375C25.25 30.1406 25.4258 29.8477 25.6602 29.7891L29 28.5Z"
                  fill="url(#paint0_linear_4667_1670)"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_4667_1670"
                  x="0.5"
                  y="0"
                  width="42"
                  height="42"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="3" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.00392157 0 0 0 0 1 0 0 0 0 0.882353 0 0 0 0.29 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4667_1670"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4667_1670"
                    result="shape"
                  />
                </filter>
                <linearGradient
                  id="paint0_linear_4667_1670"
                  x1="9.41667"
                  y1="14.75"
                  x2="35.1647"
                  y2="26.6678"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#80FF00" />
                  <stop offset="0.560947" stop-color="#10FF7E" />
                  <stop offset="1" stop-color="#00FFE0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div>
            <h1 class="mr-1 inline text-[13px]" v-html="title"></h1>
            <svg
              width="24"
              height="9"
              viewBox="0 0 24 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="inline"
            >
              <path
                d="M19.1602 8.54492C19.0234 8.43555 18.9688 8.27148 18.9688 8.08008C18.9688 7.91602 19.0234 7.75195 19.1602 7.64258L21.7578 5.01758H0.65625C0.273438 5.01758 0 4.74414 0 4.36133C0 4.00586 0.273438 3.70508 0.65625 3.70508H21.7578L19.1602 1.10742C18.8867 0.861328 18.8867 0.451172 19.1602 0.205078C19.4062 -0.0683594 19.8164 -0.0683594 20.0898 0.205078L23.8086 3.92383C24.0547 4.16992 24.0547 4.58008 23.8086 4.82617L20.0898 8.54492C19.8164 8.81836 19.4062 8.81836 19.1602 8.54492Z"
                fill="#01FFE1"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import useActions from "@/actions/useActions";
  import { ref, computed } from "vue";
  import { useGeneralStore } from "@/stores/generalStore";

  const { save } = useActions();
  const generalStore = useGeneralStore();

  const ecm = ref(
    "Work faster with an AI assistant.<br>Available only in Topol PRO  "
  );

  const title = computed(() => {
    return ecm.value;
  });

  async function clickOnBanner() {
    // prevent double click or spamming the button
    if (generalStore.saving) return;

    const data = await save();

    if (data === undefined) {
      return;
    }

    const message = {
      type: "callback",
      action: "onBannerClick",
      data: {
        args: [data.json, data.html],
      },
    };

    window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
  }
</script>

<style lang="scss" scoped>
  .propagation-box {
    background: linear-gradient(
      173deg,
      rgb(141, 255, 0) 0%,
      rgb(16, 255, 126) 37.18%,
      rgb(0, 255, 224) 59.55%,
      rgb(16, 255, 126) 100%
    );
    h1 {
      background: linear-gradient(
        127deg,
        #8dff00 0%,
        #10ff7e 56.09%,
        #00ffe0 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
</style>
